module.exports = __webpack_public_path__ + "img/notification.7fe190b9.svg";